import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dateFormat: String,
    minDate: Number
  }

  connect() {
    // timeDateFormats is a global variable defined in app/assets/javascripts/shared/helpers.js
    const options = { dateFormat: timeDateFormats.short }
    if (this.hasMinDateValue) {
      options.minDate = this.minDateValue
    }
    if (this.hasDateFormatValue) {
      options.dateFormat = this.dateFormatValue
    }
    $(this.element).datepicker(options)
  }

  disconnect() {
    $(this.element).datepicker('destroy')
  }
}
